import React from 'react'

import { Box, Paper, Stepper, Step, StepLabel } from '@material-ui/core'

import { Container, ContentHeader } from 'components'
import { Route, useParams, Redirect } from 'react-router-dom'
import { reverse } from 'named-urls'

import { routes } from 'routes'
import DetachedInvoiceSelectCustomer from './DetachedInvoiceSelectCustomer'
import DetachedInvoiceSelectPlan from './DetachedInvoiceSelectPlan'
import DetachedInvoiceSettings from './DetachedInvoiceSettings'
import DetachedInvoiceConfirm from './DetachedInvoiceConfirm'

import useWindowSize from 'hooks/useWindowSize'
import CollapseProvider from 'providers/CollapseProvider'
import DetachedInvoiceContext from 'contexts/DetachedInvoiceContext'

const DetachedInvoiceSteps = () => {
  const params = useParams()
  const windowSize = useWindowSize()
  const context = React.useContext(DetachedInvoiceContext)

  const routesSteps = React.useMemo(
    () => [
      routes.invoices.steps.selectCustomer,
      routes.invoices.steps.selectPlan,
      routes.invoices.steps.settings,
      routes.invoices.steps.confirm,
    ],
    [],
  )

  const activeStep = React.useMemo(
    () => routesSteps.findIndex(step => step.includes(params.step)),
    [routesSteps, params.step],
  )

  if (params.step !== 'select-customer' && !context.data.customer) {
    return <Redirect to={reverse(routes.invoices.steps.selectCustomer)} />
  }

  return (
    <Container>
      <ContentHeader title="Fatura avulsa" subtitle="nova" />
      <Paper>
        <Stepper activeStep={activeStep}>
          <Step>
            <StepLabel>
              {windowSize.isDesktop ? 'Selecione o cliente' : ''}
            </StepLabel>
          </Step>
          <Step>
            <StepLabel>
              {windowSize.isDesktop ? 'Selecione o plano' : ''}
            </StepLabel>
          </Step>
          <Step>
            <StepLabel>{windowSize.isDesktop ? 'Configurações' : ''}</StepLabel>
          </Step>
          <Step>
            <StepLabel>
              {windowSize.isDesktop ? 'Revisão e finalização' : ''}
            </StepLabel>
          </Step>
        </Stepper>

        <Box>
          <Route
            path={routes.invoices.steps.selectCustomer}
            component={DetachedInvoiceSelectCustomer}
          />
          <CollapseProvider>
            <Route
              path={routes.invoices.steps.selectPlan}
              component={DetachedInvoiceSelectPlan}
            />
          </CollapseProvider>
          <Route
            path={routes.invoices.steps.settings}
            component={DetachedInvoiceSettings}
          />
          <Route
            path={routes.invoices.steps.confirm}
            component={DetachedInvoiceConfirm}
          />
        </Box>
      </Paper>
    </Container>
  )
}

export default DetachedInvoiceSteps
